import _ from "lodash";
import React from "react";
import classes from "./Listview.scss";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import { getStringAutoLinks } from "Utils";
import classNames from "classnames";

class Listview extends UIBaseComponent {
  renderBulletList = value => {
    return (
      <ul className={classes.List}>
        {_.map(value, (val, index) => {
          return (
            <li
              key={index}
              dangerouslySetInnerHTML={{
                __html: getStringAutoLinks(val),
              }}
            ></li>
          );
        })}
      </ul>
    );
  };

  renderNumberList = value => {
    return (
      <ol className={classes.List}>
        {_.map(value, (val, index) => {
          return (
            <li
              key={index}
              dangerouslySetInnerHTML={{
                __html: getStringAutoLinks(val),
              }}
            ></li>
          );
        })}
      </ol>
    );
  };

  renderContent = ({ value, listType }) => {
    //If there is only one element no need to show it in list format
    if (_.size(value) === 1)
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: getStringAutoLinks(value[0]),
          }}
        />
      );
    else if (_.isEqual(listType, "number")) return this.renderNumberList(value);
    else return this.renderBulletList(value);
  };

  renderView = () => {
    const { value, listType, customTextStyle } = this.props;
    return (
      <div
        className={classNames({
          [classes.detailText]: true,
          ["text-body-1"]: true,
        })}
        style={customTextStyle}
      >
        {this.renderContent({ value, listType })}
      </div>
    );
  };
}

Listview.defaultProps = {
  ...UIBaseComponent.defaultProps,
  customTextStyle: {},
  listType: "bullet",
};

export default Listview;
